import { postFormData, post } from '../index'


export const login = postFormData('/login')
export const logout = post('/logout')
